import React from "react";
import { motion } from "framer-motion";

import { fadeIn, staggerContainer } from "../variants";

import { footerData } from "../data";
import Socials from "./Socials";

const Footer = () => {
  const {
    contact,
    hours,
    social,
    message,
    dividerImg,
    menuGallery,
    content,
    swirlImg,
  } = footerData;
  return (
    <>
      <footer className="relative top-96 z-20 lg:bg-footer lg:bg-transparent lg:min-h-[620px] lg:bg-center lg:bg-cover lg:bg-no-repeat pt-1 w-100">
        <div className="container mx-auto h-full relative">
          <motion.div
            variant={staggerContainer}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.6 }}
          >
            <motion.div
              variants={fadeIn("up", "tween", 0.2, 1.8)}
              className="absolute hidden lg:flex bottom-[-600px] right-[-400px] z-10"
            >
              <img src={swirlImg} alt="" />
            </motion.div>
          </motion.div>
        </div>

        <div className="lg:hidden container mx-auto">
          <motion.div
            variants={fadeIn("down", "tween", 0.6, 1.6)}
            initial="hidden"
            whileInView={"show"}
            className="flex-1 text-center lg:text-left lg:pt-16"
          >
            <div className="flex justify-center items-center text-red-300 h2 capitalize">
              {message?.regards}
            </div>
            <p className="flex justify-center items-center mb-[60px]">
              {message?.info}
            </p>
          </motion.div>
          <motion.div
            initial="hidden"
            whileInView={"show"}
            variants={fadeIn("down", "tween", 0.6, 1.6)}
            className="flex justify-center items-center text-center lg:hidden"
          >
            <img src={dividerImg} alt="" />
          </motion.div>
        </div>

        <div className="h-full flex mt-[5%] mb-[2%] mx-[5%] justify-center items-center lg:items-start flex-col">
          <div className="flex flex-col gap-y-12 lg:gap-y-2 lg:mb-8 justify-center items-center lg:items-start mt-8 relative z-20">
            <div className="capitalize text-[20px] lg:text-[22px] font-normal text-red-300 font-primary whitespace-nowrap	">
              <b>{content?.title}</b>
            </div>
            <div className="text-base">{content?.salut}</div>
            <div className="flex flex-col justify-center items-center mt-[10px] lg:items-start">
              <div className="text-[18px] text-red-300 text-bold font-primary">
                <b>{content?.policy?.health?.title}</b>
              </div>
              <div className="text-base	text-center lg:text-start">
                {content?.policy?.health?.content}
              </div>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row lg:gap-x-[130px] gap-y-12 lg:gap-y-0 lg:mb-12 justify-center mt-8 relative z-20">
            <div className="flex-1 text-center items-center lg:text-start lg:items-start lg:max-w-[170px]">
              <div className="capitalize text-[16px] lg:text-[18px] font-normal text-red-300 font-primary mb-[22px] whitespace-nowrap	">
                <b>{contact?.title}</b>
              </div>
              <div className="capitalize text-[14px] lg:text-[16px]">
                {contact?.phone}
              </div>
            </div>

            <div className="flex-1 text-center items-center lg:text-start lg:items-start lg:w-[170px]">
              <div className="capitalize text-[16px] lg:text-[18px] font-normal text-red-300 font-primary mb-[22px]">
                <b> {hours?.title} </b>
              </div>
              <div className="lg:flex lg:gap-x-[46px]">
                {hours?.program?.map((item, index) => {
                  return (
                    <div key={index}>
                      <div key={index}>
                        <div className="text-[14px] lg:text-[16px]" key={index}>
                          <b>{item?.days}</b>
                        </div>
                        {/* <div
                          key={index}
                          className="text-[14px] lg:text-[16px] text-red-300 text-bold"
                        >
                          {item?.hours}
                        </div> */}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="flex-1 text-center items-center lg:text-start lg:items-start lg:max-w-fit">
              <div className="capitalize text-[16px] lg:text-[18px] font-normal text-red-300 font-primary mb-[22px]">
                <b> {social?.title} </b>
              </div>
              <div className="flex justify-center text-center items-center lg:justify-start lg:text-start lg:items-start">
                <Socials />
              </div>
            </div>

            <div className="flex-1 text-center items-center lg:text-start lg:items-start lg:max-w-fit mb-12">
              <div className="capitalize text-[16px] lg:text-[18px] font-normal text-red-300 font-primary mb-[22px]">
                <b> {menuGallery?.title} </b>
              </div>
              <div className="capitalize text-[14px] lg:text-[16px]">
                {menuGallery?.info}
              </div>
            </div>
          </div>
        </div>

        <div className="h-full flex mx-[5%] mb-[2%] justify-center items-center lg:items-start flex-col">
          <div className="text-base">© 2024, Drifter's Super Whip Ltd</div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
